export class AzureDisk {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "providerDiskId",
            "baseName": "providerDiskId",
            "type": "string",
            "format": ""
        },
        {
            "name": "settings",
            "baseName": "settings",
            "type": "AzureDiskSettings",
            "format": ""
        },
        {
            "name": "isAdeEncrypted",
            "baseName": "isAdeEncrypted",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "adeKeyVaultSubscriptionId",
            "baseName": "adeKeyVaultSubscriptionId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureDisk.attributeTypeMap;
    }
    constructor() {
    }
}
